import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {create} from "../../../app/setters/create.js";
import useCopyToClipboard from "../../../../hooks/useCopyToClipboard.js";


export const useUtworzProfil = (setErrors) => {
const [_value, copy] = useCopyToClipboard()

    const queryClient = useQueryClient();
    const role = useSelector(state => state.user.role);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    return useMutation({
        mutationFn: (data) => create(`/oper/profile`, data),
        onError: (err) => {
            setErrors(err.response.data.errors);
            toast.error('Błąd podczas operacji')
        },

        onSettled: async (data) => {
            if (data?.status === 'success' && data?.id) {
                copy(data.password)
                toast.info(
                    <div>
                        Jednorazowe hasło do aktywacji profilu: <br />
                        <strong>{data.password}</strong>
                        <button
                            style={{marginLeft: 8}}
                            onClick={e => {
                                e.stopPropagation();
                                copy(data.password);
                            }}
                        >
                            Kopiuj
                        </button>
                        <div>Przekaż je odpowiedniej osobie.</div>
                    </div>,
                    {autoClose: false}
                )
            }
            await queryClient.invalidateQueries({
                predicate: query => query.queryKey[0].startsWith(`oper_profile`),
            });
        },


        onSuccess: ({message, status}) => {
            dispatch(setSilent(true))
            navigate(`/${role}/profile/lista`)
            status === 'success' ? toast.success(message) : toast.error(message)
        },
    })
}